import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stkmr { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '商品代號 (MR001) 不可空白'}) 
    @MaxLength(8,{message: '商品代號 (MR001) 資料太長'})
    MR001: string = '';            // 商品代號 8 只有最新.無歷史  格式1

    @IsNotEmpty({message: '帳號 (MR002) 不可空白'}) 
    @MaxLength(20,{message: '帳號 (MR002) 資料太長'})
    MR002: string = '';            // 帳號 20 ACCOUNT_NO

    @IsNotEmpty({message: '登入代號 (MR003) 不可空白'}) 
    @MaxLength(10,{message: '登入代號 (MR003) 資料太長'})
    MR003: string = '';            // 登入代號 10 LOGIN_ID


    MR004: Date | undefined;            // datetime 0 更新時間

    @MaxLength(2,{message: '市場別 (MR005) 資料太長'})
    MR005: string = '';            // 市場別 2 

    @IsNumber() 
    MR006: number = 0;            // 買賣別 3 B=1 S=-1 {{1:買 -1:賣}}

    @IsNumber() 
    MR007: number = 0;            // 未平倉部位 8 

    @IsNumber() 
    MR008: number = 0;            // 當沖未平倉部位 8 

    @IsNumber() 
    MR009: number = 0;            // 平均成本 11.3 (小數部分已處理)

    @IsNumber() 
    MR010: number = 0;            // 單口手續費 8.3 

    @IsNumber() 
    MR011: number = 0;            // 交易稅 11.2 (萬分之X)

    @IsNumber() 
    MR012: number = 0;            // 一點價值 8 


}
